import React, { Component } from 'react';
import { tipoUnidad } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox) => {
    let body = "";
    body = data.map((register, index) => {
        return (
            <tr key={index}>
                {headers[0].value && <td className="dataTables-body-center">{register.key}</td>}
                {headers[1].value && <td className="dataTables-body-center">{register.value || ''}</td>}
                {headers[1].value && <td className="dataTables-body-center">{register.Configuration || ''}</td>}
                <td className="sticky-columns dataTables-body-center" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => checkbox.openDetails(register)}
                        style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )
    })
    return body;
};

const renderTable = (headers, data, checkbox) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td className="dataTables-header-center">{headers[0].title}</td>}
            {headers[1].value && <td className="dataTables-header-center">{headers[1].title}</td>}
            {headers[2].value && <td className="dataTables-header-center">{headers[2].title}</td>}
            <td className="sticky-columns dataTables-header-center" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>
        </tr>;
    }

    body = renderTableBody(headers, data, checkbox);

    let table = "";

    table = <table id="dataTableTrResume" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableTransportsResume = (headers, data, checkbox) => {

    return renderTable(headers, data, checkbox);

}